import ReactDOM from 'react-dom/client'
import App from './app'
import 'src/services/sentry'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(App())

export default root
